export const COUNTRIES = [
  { code: 'FR', name: 'France', flag: '🇫🇷' },
  { code: 'DE', name: 'Allemagne', flag: '🇩🇪' },
  { code: 'BE', name: 'Belgique', flag: '🇧🇪' },
  { code: 'NL', name: 'Pays-Bas', flag: '🇳🇱' },
  { code: 'GB', name: 'Royaume-Uni', flag: '🇬🇧' },
  { code: 'ES', name: 'Espagne', flag: '🇪🇸' },
  { code: 'BJ', name: 'Bénin', flag: '🇧🇯' },
  { code: 'BF', name: 'Burkina Faso', flag: '🇧🇫' },
  { code: 'CI', name: "Côte d'Ivoire", flag: '🇨🇮' },
  { code: 'SN', name: 'Sénégal', flag: '🇸🇳' },
  { code: 'TG', name: 'Togo', flag: '🇹🇬' },
  { code: 'CA', name: 'Canada', flag: '🇨🇦' },
  { code: 'CH', name: 'Suisse', flag: '🇨🇭' },
  { code: 'LU', name: 'Luxembourg', flag: '🇱🇺' },
  { code: 'ZA', name: 'Afrique du Sud', flag: '🇿🇦' },
] as const;

export type CountryCode = (typeof COUNTRIES)[number]['code'];

export const AUTHORITIES: Record<string, { code: string; name: string; url: string }[]> = {
  FR: [
    { code: 'MEN', name: "Ministère de l'Éducation nationale", url: 'https://eduscol.education.fr' },
    { code: 'AC-PARIS', name: 'Académie de Paris', url: 'https://www.ac-paris.fr' },
    { code: 'AC-LYON', name: 'Académie de Lyon', url: 'https://www.ac-lyon.fr' },
    { code: 'AC-BORDEAUX', name: 'Académie de Bordeaux', url: 'https://www.ac-bordeaux.fr' },
    { code: 'AC-MARSEILLE', name: "Académie d'Aix-Marseille", url: 'https://www.ac-aix-marseille.fr' },
    { code: 'AC-NANTES', name: 'Académie de Nantes', url: 'https://www.ac-nantes.fr' },
    { code: 'AC-TOULOUSE', name: 'Académie de Toulouse', url: 'https://www.ac-toulouse.fr' },
    { code: 'AC-RENNES', name: 'Académie de Rennes', url: 'https://www.ac-rennes.fr' },
    { code: 'AC-STRASBOURG', name: 'Académie de Strasbourg', url: 'https://www.ac-strasbourg.fr' },
    { code: 'AC-LILLE', name: 'Académie de Lille', url: 'https://www.ac-lille.fr' },
    { code: 'AC-VERSAILLES', name: 'Académie de Versailles', url: 'https://www.ac-versailles.fr' },
    { code: 'AC-CRETEIL', name: 'Académie de Créteil', url: 'https://www.ac-creteil.fr' },
  ],
  DE: [{ code: 'KMK', name: 'Kultusministerkonferenz', url: 'https://www.kmk.org' }],
  BE: [
    { code: 'FWB', name: 'Fédération Wallonie-Bruxelles', url: 'https://www.fw-b.be' },
    { code: 'VL', name: 'Vlaamse overheid', url: 'https://onderwijs.vlaanderen.be' },
  ],
  NL: [{ code: 'OCW', name: 'Ministerie van Onderwijs', url: 'https://www.rijksoverheid.nl/ministeries/ocw' }],
  GB: [
    { code: 'OFSTED', name: 'Ofsted (England)', url: 'https://www.gov.uk/ofsted' },
    { code: 'ESTYN', name: 'Estyn (Wales)', url: 'https://www.estyn.gov.wales' },
    { code: 'ES', name: 'Education Scotland', url: 'https://education.gov.scot' },
  ],
  ES: [
    {
      code: 'MEFPD',
      name: 'Ministerio de Educación, Formación Profesional y Deportes',
      url: 'https://www.educacionfpydeportes.gob.es',
    },
  ],
  BJ: [
    {
      code: 'MESTFP',
      name: "Ministère des Enseignements Secondaire, Technique et de la Formation Professionnelle",
      url: 'https://www.enseignementsecondaire.gouv.bj',
    },
  ],
  BF: [
    {
      code: 'MENAPLN',
      name: "Ministère de l'Éducation Nationale, de l'Alphabétisation et de la Promotion des Langues Nationales",
      url: 'https://www.education.gov.bf',
    },
  ],
  CI: [
    {
      code: 'MENA',
      name: "Ministère de l'Éducation Nationale et de l'Alphabétisation",
      url: 'https://education.gouv.ci',
    },
  ],
  SN: [
    { code: 'MEN', name: "Ministère de l'Éducation nationale", url: 'https://www.education.sn' },
  ],
  TG: [
    { code: 'MEN', name: "Ministère de l'Éducation Nationale", url: 'https://education.gouv.tg' },
  ],
  // Canada has no federal education ministry — it's provincial jurisdiction.
  // Covers the three largest provinces, same pattern as GB (England/Wales/Scotland).
  CA: [
    {
      code: 'ON',
      name: 'Ministry of Education (Ontario)',
      url: 'https://www.ontario.ca/page/ministry-education',
    },
    {
      code: 'QC',
      name: "Ministère de l'Éducation (Québec)",
      url: 'https://www.quebec.ca/education',
    },
    {
      code: 'BC',
      name: 'Ministry of Education and Child Care (British Columbia)',
      url: 'https://gov.bc.ca/ecc',
    },
  ],
  // Switzerland has no federal education ministry either — cantonal
  // jurisdiction, coordinated nationally via the CDIP, same pattern as DE's KMK.
  CH: [
    {
      code: 'CDIP',
      name: "Conférence suisse des directeurs cantonaux de l'instruction publique",
      url: 'https://www.edk.ch',
    },
  ],
  LU: [
    {
      code: 'MENEJ',
      name: "Ministère de l'Éducation nationale, de l'Enfance et de la Jeunesse",
      url: 'https://men.public.lu',
    },
  ],
  ZA: [
    { code: 'DBE', name: 'Department of Basic Education', url: 'https://www.education.gov.za' },
  ],
};

export const SCHOOL_YEARS: Record<string, { hs: string[]; uni: string[] }> = {
  FR: {
    hs: ['6ème', '5ème', '4ème', '3ème', '2nde', '1ère', 'Terminale'],
    uni: ['Licence 1', 'Licence 2', 'Licence 3', 'Master 1', 'Master 2'],
  },
  DE: {
    hs: ['Klasse 5', 'Klasse 6', 'Klasse 7', 'Klasse 8', 'Klasse 9', 'Klasse 10', 'Klasse 11', 'Klasse 12', 'Klasse 13'],
    uni: ['1. Semester', '2. Semester', '3. Semester', '4. Semester', '5. Semester', '6. Semester'],
  },
  BE: {
    hs: ['1re', '2e', '3e', '4e', '5e', '6e'],
    uni: ['Bac 1', 'Bac 2', 'Bac 3', 'Master 1', 'Master 2'],
  },
  NL: {
    hs: ['Klas 1', 'Klas 2', 'Klas 3', 'Klas 4', 'Klas 5', 'Klas 6'],
    uni: ['Jaar 1', 'Jaar 2', 'Jaar 3', 'Master 1', 'Master 2'],
  },
  GB: {
    hs: ['Year 7', 'Year 8', 'Year 9', 'Year 10', 'Year 11', 'Year 12', 'Year 13'],
    uni: ['Year 1', 'Year 2', 'Year 3', 'Year 4 (Masters)'],
  },
  ES: {
    hs: ['1º ESO', '2º ESO', '3º ESO', '4º ESO', '1º Bachillerato', '2º Bachillerato'],
    uni: ['1º curso', '2º curso', '3º curso', '4º curso'],
  },
  // Bénin, Burkina Faso, Côte d'Ivoire, Sénégal, Togo share the French-derived
  // collège/lycée + LMD structure — same progression as FR.
  BJ: {
    hs: ['6ème', '5ème', '4ème', '3ème', '2nde', '1ère', 'Terminale'],
    uni: ['Licence 1', 'Licence 2', 'Licence 3', 'Master 1', 'Master 2'],
  },
  BF: {
    hs: ['6ème', '5ème', '4ème', '3ème', '2nde', '1ère', 'Terminale'],
    uni: ['Licence 1', 'Licence 2', 'Licence 3', 'Master 1', 'Master 2'],
  },
  CI: {
    hs: ['6ème', '5ème', '4ème', '3ème', '2nde', '1ère', 'Terminale'],
    uni: ['Licence 1', 'Licence 2', 'Licence 3', 'Master 1', 'Master 2'],
  },
  SN: {
    hs: ['6ème', '5ème', '4ème', '3ème', '2nde', '1ère', 'Terminale'],
    uni: ['Licence 1', 'Licence 2', 'Licence 3', 'Master 1', 'Master 2'],
  },
  TG: {
    hs: ['6ème', '5ème', '4ème', '3ème', '2nde', '1ère', 'Terminale'],
    uni: ['Licence 1', 'Licence 2', 'Licence 3', 'Master 1', 'Master 2'],
  },
  // English-Canada convention (Ontario/BC/etc.) — Quebec's Secondaire 1-5 +
  // CEGEP system is genuinely different and not represented here; a student
  // can still type/select freely since study_level isn't backend-validated
  // against this list, but the dropdown itself won't show Quebec's own terms.
  CA: {
    hs: ['Grade 9', 'Grade 10', 'Grade 11', 'Grade 12'],
    uni: ['Year 1', 'Year 2', 'Year 3', 'Year 4'],
  },
  ZA: {
    hs: ['Grade 8', 'Grade 9', 'Grade 10', 'Grade 11', 'Grade 12'],
    uni: ['Year 1', 'Year 2', 'Year 3', 'Year 4'],
  },
  // 7e/6e/5e are "classes inférieures", 4e-1re are "classes supérieures" —
  // real Luxembourg secondary-general nomenclature (descending, unlike BE's
  // ascending 1re-6e above). Higher ed follows the standard Bologna
  // Bachelor/Master naming, same convention as BE's own uni entry.
  LU: {
    hs: ['7e', '6e', '5e', '4e', '3e', '2e', '1re'],
    uni: ['Bachelor 1', 'Bachelor 2', 'Bachelor 3', 'Master 1', 'Master 2'],
  },
  // CH intentionally omitted: secondary-school naming varies genuinely by
  // canton (Genève "Collège", Vaud "Gymnase", Neuchâtel/Jura "Lycée", 3- vs
  // 4-year cycles) with no single accurate universal list — falls back to
  // FR's terms via getSchoolYears() below until a canton-aware picker exists,
  // same "not yet modeled" pattern as TRACKS' own doc comment.
};

// AddChildPage used to hardcode spelled-out French year names ("Seconde",
// "Première") before it switched to this file's abbreviated SCHOOL_YEARS
// convention ("2nde", "1ère") — existing profiles saved under the old
// spelling would otherwise match no SCHOOL_YEARS/TRACKS option at all,
// making the level appear blank and, worse, making any real edit look like
// an academic-year change (see ParentChildDetailView's reset-trigger logic).
const LEGACY_SCHOOL_YEAR_ALIASES: Record<string, string> = {
  Seconde: '2nde',
  Première: '1ère',
};

export function normalizeSchoolYear(year: string): string {
  return LEGACY_SCHOOL_YEAR_ALIASES[year] ?? year;
}

export interface TrackConfig {
  /** Display label for the picker, e.g. "Spécialités" — left untranslated,
   * same as school-year strings like "Terminale" are today. */
  label: string;
  /** Which SCHOOL_YEARS.hs entries show this picker (e.g. only Première/Terminale in France). */
  years: string[];
  /** 3 for French spécialités; 1 for a single-série system. */
  maxSelect: number;
  /** Curriculum-specific option names, untranslated. */
  options: string[];
}

// Only France is populated today — other countries simply show no picker
// (specializations stays an empty list) until their own série/track system
// is added here; no other code needs to change when that happens.
export const TRACKS: Record<string, TrackConfig> = {
  FR: {
    label: 'Spécialités',
    years: ['1ère', 'Terminale'],
    maxSelect: 3,
    options: [
      'Mathématiques',
      'Physique-Chimie',
      'SVT',
      'SES',
      'HGGSP',
      'HLP',
      'LLCE',
      'NSI',
      'SI',
      'Arts',
      'Biologie-Écologie',
      'Mathématiques expertes',
      'Mathématiques complémentaires',
    ],
  },
};

export function getTrackConfig(country: string, schoolYear: string): TrackConfig | null {
  const cfg = TRACKS[country];
  return cfg && cfg.years.includes(normalizeSchoolYear(schoolYear)) ? cfg : null;
}

export function getCountryName(code: string): string {
  return COUNTRIES.find((c) => c.code === code)?.name ?? code;
}

export function getCountryFlag(code: string): string {
  return COUNTRIES.find((c) => c.code === code)?.flag ?? '';
}

export function getAuthorityName(country: string, authorityCode: string): string {
  return AUTHORITIES[country]?.find((a) => a.code === authorityCode)?.name ?? authorityCode;
}

export function getSchoolYears(country: string, mode: 'high_school' | 'university'): string[] {
  const entry = SCHOOL_YEARS[country] ?? SCHOOL_YEARS['FR']!;
  return mode === 'university' ? entry.uni : entry.hs;
}
